module.exports = __webpack_public_path__ + "assets/images/226269ace90e25712954cb873dccd712.avif";